module.exports = __webpack_public_path__ + "static/media/2.ce29c22e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/thumbs/2.jpg
// module id = 150
// module chunks = 0